import _regeneratorRuntime from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { URL_CREATE_PAYMENTS, URL_AUTHENTICATE_PAYMENTS } from '../../constants/endpointConstants.js';
var _createPayment = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(methodId) {
    var response, data, split, newMethodId;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch(URL_CREATE_PAYMENTS, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              methodId: methodId
            })
          });
        case 3:
          response = _context.sent;
          _context.next = 6;
          return response.json();
        case 6:
          data = _context.sent;
          if (!(response.status === 422)) {
            _context.next = 11;
            break;
          }
          split = methodId.split(':');
          newMethodId = split.length >= 2 ? "".concat(split[0], ":").concat(split[1]) : methodId;
          return _context.abrupt("return", _createPayment(newMethodId));
        case 11:
          return _context.abrupt("return", data);
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](0);
          console.error('Failed to create Stripe payment:', _context.t0);
          throw _context.t0;
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 14]]);
  }));
  return function createPayment(_x) {
    return _ref.apply(this, arguments);
  };
}();
var confirmPayment = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(jlppr) {
    var response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return fetch(URL_AUTHENTICATE_PAYMENTS(jlppr), {
            method: 'POST'
          });
        case 3:
          response = _context2.sent;
          if (response.ok) {
            _context2.next = 6;
            break;
          }
          throw new Error("API Error: ".concat(response.status, " - ").concat(response.statusText));
        case 6:
          return _context2.abrupt("return", response);
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          console.error('Failed to confirmPayment:', _context2.t0);
          throw _context2.t0;
        case 13:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 9]]);
  }));
  return function confirmPayment(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export { confirmPayment, _createPayment as createPayment };